import React, { useState, useContext } from "react";
import styled from "styled-components";
// Assets
import ContactImg1 from "../../assets/img/machine_snapshot.jpg";
import ContactImg2 from "../../assets/img/machine_snapshot1.jpg";
import ContactImg3 from "../../assets/img/machine_snapshot2.jpg";
import { LanguageContext } from "../../screens/LanguageContext"; // Import the context
import emailjs from "emailjs-com";


export default function Contact() {
  const { language } = useContext(LanguageContext); // Access the language context

  // Translations based on selected language
  const translations = {
    en: {
      title: "Let's Get in Touch",
      description:
        "We would love to hear from you! Whether you have questions, comments, or just want to chat, feel free to reach out to us. Our team is always happy to assist with any inquiries or feedback you may have.",
      from_name: "First Name:",
      email: "Email:",
      subject: "Subject:",
      message: "Message:",
      submit: "Send Message",
    },
    ar: {
      title: "لنلتقي ونتواصل",
      description:
        "يسعدنا سماع منك! سواء كان لديك أسئلة أو تعليقات أو كنت ترغب فقط في الدردشة، لا تتردد في التواصل معنا. فريقنا دائمًا سعيد بمساعدتك في أي استفسارات أو ملاحظات قد تكون لديك.",
      from_name: "الاسم الأول:",
      email: "البريد الإلكتروني:",
      subject: "الموضوع:",
      message: "الرسالة:",
      submit: "إرسال الرسالة",
    },
  };

  const { title, description, from_name, email, subject, message, submit } =
    translations[language];

  // State to handle form input values
  const [formData, setFormData] = useState({
    from_name: "",
    email: "",
    subject: "",
    message: "",
  });

  // Handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault(); // Prevent page reload on submit

    // Validate the form (optional, enhance as needed)
    if (
      !formData.from_name ||
      !formData.email ||
      !formData.subject ||
      !formData.message
    ) {
      alert("Please fill in all fields before submitting.");
      return;
    }
    // Send email using emailjs
    emailjs
    .send(
      process.env.REACT_APP_SERVICE_ID,
      process.env.REACT_APP_TEMPLATE_ID,
      formData,
      process.env.REACT_APP_USER_ID
    )
      .then(
        (response) => {
          console.log("SUCCESS!", response.status, response.text);
          alert("Your message has been sent successfully!");
          // Reset form after successful submission
          setFormData({
            from_name: "",
            email: "",
            subject: "",
            message: "",
          });
        },
        (error) => {
          console.error("FAILED...", error);
          alert("There was an error sending your message. Please try again.");
        }
      );
  };

  return (
    <Wrapper id="contact">
      <div className="lightBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">{title}</h1>
            <p className="font13">{description}</p>
          </HeaderInfo>
          <div className="row" style={{ paddingBottom: "30px" }}>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <Form onSubmit={handleSubmit}>
                <label className="font13">{from_name}</label>
                <input
                  type="text"
                  id="from_name"
                  name="from_name"
                  value={formData.from_name}
                  onChange={handleInputChange}
                  className="font20 extraBold"
                />
                <label className="font13">{email}</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  className="font20 extraBold"
                />
                <label className="font13">{subject}</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleInputChange}
                  className="font20 extraBold"
                />
                <label className="font13">{message}</label>
                <textarea
                  rows="4"
                  cols="50"
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  className="font20 extraBold"
                ></textarea>
                <SumbitWrapper className="flex">
                  <ButtonInput
                    type="submit"
                    value={submit}
                    className="pointer animate radius8 greenBg whiteColor"
                    style={{
                      backgroundColor: "rgb(43, 101, 66)",
                      borderColor: "rgb(43, 101, 66)",
                      cursor: "pointer",
                    }}
                  />
                </SumbitWrapper>
              </Form>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 flex">
              <div
                style={{ width: "50%" }}
                className="flexNullCenter flexColumn"
              >
                <ContactImgBox>
                  <img
                    src={ContactImg1}
                    alt="Office View 1"
                    className="radius6"
                  />
                </ContactImgBox>
                <ContactImgBox>
                  <img
                    src={ContactImg2}
                    alt="Office View 2"
                    className="radius6"
                  />
                </ContactImgBox>
              </div>
              <div style={{ width: "50%" }}>
                <div style={{ marginTop: "100px" }}>
                  <img
                    src={ContactImg3}
                    alt="Office View 3"
                    className="radius6"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
`;

const HeaderInfo = styled.div`
  padding: 70px 0 30px 0;
  @media (max-width: 860px) {
    text-align: center;
  }
`;

const Form = styled.form`
  padding: 70px 0 30px 0;
  input,
  textarea {
    width: 100%;
    background-color: transparent;
    border: 0px;
    outline: none;
    box-shadow: none;
    border-bottom: 1px solid #707070;
    margin-bottom: 30px;
  }
  textarea {
    min-height: 100px;
  }
  @media (max-width: 860px) {
    padding: 30px 0;
  }
`;

const ButtonInput = styled.input`
  border: 1px solid #7620ff;
  background-color: #7620ff;
  width: 100%;
  padding: 15px;
  outline: none;
  color: #fff;
  :hover {
    background-color: #580cd2;
    border: 1px solid #7620ff;
    color: #fff;
  }
  @media (max-width: 991px) {
    margin: 0 auto;
  }
`;

const ContactImgBox = styled.div`
  max-width: 180px;
  align-self: flex-end;
  margin: 10px 30px 10px 0;
`;

const SumbitWrapper = styled.div`
  @media (max-width: 991px) {
    width: 100%;
    margin-bottom: 50px;
  }
`;
